import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { getLinks } from "@cinch-nx/data-storyblok";
import { tagError } from "@core/datadog-server";
function createStaticPaths(links) {
    var paths = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(links)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var link = _step.value;
            // should look like /car-reviews-v2/ford/focus/2022
            var ref = _sliced_to_array(link.slug.split("/"), 4), make = ref[1], model = ref[2], slug = ref[3];
            // if it does not match, we don't want it
            if (make !== undefined && model !== undefined && slug !== undefined) {
                paths.push({
                    params: {
                        make: make,
                        model: model,
                        slug: slug
                    }
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return paths;
}
export var getStaticPaths = function() {
    var _ref = _async_to_generator(function() {
        var links, paths, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getLinks("car-reviews-v2/")
                    ];
                case 1:
                    links = _state.sent();
                    paths = createStaticPaths(links);
                    return [
                        2,
                        {
                            paths: paths,
                            fallback: "blocking"
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Error fetching links for car-reviews-v2: ".concat(error));
                    if (_instanceof(error, Error) || typeof error === "string") {
                        tagError(error);
                    }
                    return [
                        2,
                        {
                            paths: [],
                            fallback: "blocking"
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getStaticPaths() {
        return _ref.apply(this, arguments);
    };
}();
